import { useSelector, useDispatch } from "react-redux";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {
  setFlowVersionsDialogOpen,
  setCreateFlowVersionDialogOpen
} from "redux/actions/flowDesigner/flowsActionCreator";
import useFlowVersions from "hooks/useFlowVersions";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";

const TitlebarFlowModeMenu = ({ state, close }) => {
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const { changeMode } = useFlowVersions(null, false);
  const dispatch = useDispatch();
  const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
  const { allowEditWorkflow } = useAllowEditWorkflow();

  const handleChangeFlowMode = async () => {
    await changeMode();

    close();
  };

  const menuAction = (action) => {
    switch (action) {
      case "create_version":
        dispatch(setCreateFlowVersionDialogOpen(true));
        break;
      case "view_all_versions":
        dispatch(setFlowVersionsDialogOpen(true));
        break;
      case "change_to_active":
        handleChangeFlowMode();
        break;
      default:
        break;
    }
    close();
  };

  const renderMenuItems = () => {
    return (
      <div>
        <MenuItem
          disabled={!allowEditWorkflow(isReadOnlyAccess)}
          onClick={() => menuAction("create_version")}
        >
          Create new version
        </MenuItem>
        <MenuItem onClick={() => menuAction("view_all_versions")}>View all versions</MenuItem>
      </div>
    );
  };

  return (
    <Menu
      anchorEl={state}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(state)}
      onClose={close}
      keepMounted
      sx={{ marginTop: "10px" }}
    >
      {renderMenuItems()}
    </Menu>
  );
};

export default TitlebarFlowModeMenu;
